/* eslint-disable react/jsx-props-no-spreading */

import noop from 'lodash/noop'
import {
    DateTimePicker,
} from '@mui/x-date-pickers'
import {
    renderTimeViewClock,
} from '@mui/x-date-pickers/timeViewRenderers'

import {
    Moment,
} from 'moment'
import {
    dateTimeMask,
    minDate,
    strToMoment,
} from 'app/utils/date'
import Label from 'app/shared-components/Label'

import InputSingleline from '../InputSingleline'
import {
    useDateInputError,
} from '../DateSelect'
import useStyles from './DateTimeSelect.styles'

export type DateTimeSelectProps = {
    title?: string,
    name?: string,
    onChange?: (value: Moment) => void,
    disabled?: boolean,
    required?: boolean,
    value?: string,
    className?: string,
    disableFuture?: boolean,
    maxDate?: string,
    setErrors?: (error: string[]) => void,
}

const EMPTY_STRING = ''

const DateTimeSelect = ({
    title = EMPTY_STRING,
    name = EMPTY_STRING,
    onChange = noop,
    disabled = false,
    required = false,
    value = EMPTY_STRING,
    className = EMPTY_STRING,
    disableFuture = false,
    maxDate,
    setErrors = noop,
}: Readonly<DateTimeSelectProps>) => {
    const {
        classes,
        cx,
    } = useStyles()

    const {
        onError,
        isError,
    } = useDateInputError({
        name,
        setFormError: setErrors,
    })

    if (disabled) {
        return (
            <InputSingleline
                name={name}
                title={title}
                value={value}
                disabled
            />
        )
    }

    return (
        <div className={cx(classes.calendar, className)}>
            <Label
                title={title}
            />
            <div
                className={cx({
                    [classes.isRequired]: required,
                    [classes.inputError]: isError,
                })}
                data-testid={`dateTimeSelect-${name}`}
            >
                <div
                    className={cx({
                        [classes.requiredMark]: true,
                        [classes.requiredMarkError]: isError,
                    })}
                    data-testid={`dateTimeSelect-requiredMark-${name}`}
                />
                <DateTimePicker
                    disableFuture={disableFuture}
                    ampm={false}
                    value={strToMoment(value, dateTimeMask)}
                    onChange={onChange}
                    format={dateTimeMask}
                    maxDate={maxDate ? strToMoment(maxDate) : undefined}
                    minDate={strToMoment(minDate)}
                    className={classes.dateTimePicker}
                    viewRenderers={
                        {
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                        }
                    }
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            fullWidth: true,
                        },
                    }}
                    onError={onError}
                />
            </div>
        </div>
    )
}

export default DateTimeSelect
